<template>
  <div class="flex flex-col items-center justify-center w-full p-16">
    <div class="flex flex-col w-full max-w-6xl justify-center pt-10">
      <div class="flex flex-col items-start w-full lg:w-1/2 mb-12">
        <h1 class="font-montserrat text-cw-900 font-black text-5xl">
          {{ title }}
        </h1>
      </div>
      <div class="w-full overflow-hidden">
        <div
          ref="inner"
          class="whitespace-nowrap inline-flex transition"
          :style="innerStyles"
        >
          <!-- Partner logos Show reel -->
          <div
            v-for="(partner, i) in partners"
            :key="i"
            class="w-32 h-32 mx-4 my-4 flex justify-center items-center relative bg-gradient-to-tr from-pink-600 to-purple-700 rounded-xl overflow-hidden"
          >
            <a
              :href="partner.site_url"
              class="w-full h-full absolute top-0 left-0 p-2"
            >
              <img
                :src="partner.logo"
                :alt="partner.id"
                class="w-full h-full object-cover rounded-md bg-white"
              />
            </a>
          </div>
        </div>
      </div>
      <div class="w-full flex justify-between">
        <div
          class="p-4 hover:text-cw-alt text-black cursor-pointer"
          @click="prev()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 featured-post-arrow"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M7 16l-4-4m0 0l4-4m-4 4h18"
            />
          </svg>
        </div>
        <div
          class="p-4 hover:text-cw-alt text-black cursor-pointer"
          @click="next()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 featured-post-arrow"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M17 8l4 4m0 0l-4 4m4-4H3"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    title: { type: String, default: 'Our Partners' },
  },

  data() {
    return {
      partners: [],
      innerStyles: {},
      step: '',
      transitioning: false,
      timer: null,
    }
  },

  computed: {
    ...mapGetters({ settings: 'shared/getSettings' }),
  },

  mounted() {
    this.setPartners()
    this.setStep()
    this.resetTranslate()
  },

  methods: {
    setPartners() {
      // Partner list is only for contributors as of 2025
      const contributors = this.settings?.featured_contributors

      this.partners = contributors
        .sort(() => Math.random() - 0.5)
        // Remove duplicate ids - we only need unique ids for the UI display
        .map((partner, index) => {
          return { ...partner, id: index }
        })
    },

    setStep() {
      const innerWidth = this.$refs.inner.scrollWidth
      const totalPartners = this.partners.length
      this.step = `${innerWidth / totalPartners}px`
      this.timer = setInterval(this.next, 3000)
    },

    next() {
      if (this.transitioning) {
        return
      }
      this.transitioning = true
      this.moveLeft()
      this.afterTransition(() => {
        const partner = this.partners.shift()
        this.partners.push(partner)
        this.resetTranslate()
        this.transitioning = false
      })
    },

    prev() {
      if (this.transitioning) {
        return
      }
      this.transitioning = true
      this.moveRight()
      this.afterTransition(() => {
        const partner = this.partners.pop()
        this.partners.unshift(partner)
        this.resetTranslate()
        this.transitioning = false
      })
    },

    afterTransition(callback) {
      if (this.$refs?.inner) {
        const listener = () => {
          callback()
          this.$refs.inner.removeEventListener('transitionend', listener)
        }
        this.$refs.inner.addEventListener('transitionend', listener)
      }
    },

    resetTranslate() {
      this.innerStyles = {
        transition: 'none',
        transform: `translateX(-${this.step})`,
      }
    },

    moveLeft() {
      this.innerStyles = {
        transform: `translateX(-${this.step})
                            translateX(-${this.step})`,
      }
    },

    moveRight() {
      this.innerStyles = {
        transform: `translateX(${this.step})
                            translateX(-${this.step})`,
      }
    },
  },
}
</script>
